import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Imposto } from '../models/tributos.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TributosService {
  private apiUrl = `${environment.advContabilApi}/api/Tributo`;

  constructor(private http: HttpClient) { }

  listarPorUsuario(usuarioId: string): Observable<Imposto[]> {
    return this.http.get<Imposto[]>(`${this.apiUrl}/ListarPorUsuario?usuarioId=${usuarioId}`);
  }

  listarComFiltros(filtro: any): Observable<Imposto[]> {
    return this.http.post<Imposto[]>(`${this.apiUrl}/ListarComFiltros`, filtro);
  }

  obterPorId(id: string): Observable<Imposto> {
    return this.http.get<Imposto>(`${this.apiUrl}/ObterPorId/${id}`);
  }

  inserir(tributoData: FormData): Observable<Imposto> {
    return this.http.post<Imposto>(`${this.apiUrl}/Inserir`, tributoData);
  }

  atualizar(tributoData: FormData): Observable<Imposto> {
    return this.http.put<Imposto>(`${this.apiUrl}/Atualizar`, tributoData);
  }

  excluir(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/Excluir/${id}`);
  }

  atualizarStatusPagamento(statusUpdate: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/AtualizarStatusPagamento`, statusUpdate);
  }

  baixarArquivo(id: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/BaixarArquivo/${id}`, { responseType: 'blob' });
  }
} 